export const questions = [
    {
      difficulty: "easy",
      prompt: "Which planet is known as the Red Planet?",
      choices: [
        "Earth",
        "Mars",
        "Venus",
        "Jupiter"
      ],
      answers: ["mars"]
    },
    {
      difficulty: "easy",
      prompt: "What is the capital city of Japan?",
      choices: [
        "Osaka",
        "Tokyo",
        "Kyoto",
        "Nagoya"
      ],
      answers: ["tokyo"]
    },
    {
      difficulty: "easy",
      prompt: "What gas do plants absorb from the atmosphere?",
      choices: [
        "Oxygen",
        "Carbon Dioxide",
        "Hydrogen",
        "Nitrogen"
      ],
      answers: ["carbon dioxide", "co2"]
    },
    {
      difficulty: "easy",
      prompt: "How many continents are on Earth?",
      choices: [
        "5",
        "6",
        "7",
        "8"
      ],
      answers: ["7", "seven"]
    },
    {
      difficulty: "easy",
      prompt: "Which ocean is the largest?",
      choices: [
        "Atlantic",
        "Pacific",
        "Indian",
        "Arctic"
      ],
      answers: ["pacific", "pacific ocean"]
    },
  
    // SCIENCE
    {
      difficulty: "easy",
      prompt: "What force pulls objects toward Earth?",
      choices: [
        "Magnetism",
        "Gravity",
        "Friction",
        "Pressure"
      ],
      answers: ["gravity"]
    },
    {
      difficulty: "easy",
      prompt: "What is H2O?",
      choices: [
        "Water",
        "Hydrogen",
        "Oxygen",
        "Salt"
      ],
      answers: ["water"]
    },
    {
      difficulty: "easy",
      prompt: "Which gas do humans breathe in?",
      choices: [
        "Carbon Dioxide",
        "Oxygen",
        "Helium",
        "Nitrogen"
      ],
      answers: ["oxygen"]
    },
  
    // MATH
    {
      difficulty: "easy",
      prompt: "What is the square root of 64?",
      choices: [
        "6",
        "7",
        "8",
        "9"
      ],
      answers: ["8", "eight"]
    },
    {
      difficulty: "easy",
      prompt: "What is 12 × 12?",
      choices: [
        "124",
        "122",
        "144",
        "140"
      ],
      answers: ["144"]
    },
  
    // HISTORY
    {
      difficulty: "easy",
      prompt: "Who was the first President of the United States?",
      choices: [
        "Abraham Lincoln",
        "George Washington",
        "Thomas Jefferson",
        "John Adams"
      ],
      answers: ["george washington", "washington"]
    },
    {
      difficulty: "easy",
      prompt: "Which ancient civilization built the pyramids?",
      choices: [
        "Romans",
        "Greeks",
        "Egyptians",
        "Chinese"
      ],
      answers: ["egyptians", "egypt"]
    },
    {
      difficulty: "easy",
      prompt: "In which year did World War II end?",
      choices: [
        "1939",
        "1945",
        "1950",
        "1960"
      ],
      answers: ["1945"]
    },
  
    // TECHNOLOGY
    {
      difficulty: "easy",
      prompt: "What does CPU stand for?",
      choices: [
        "Computer Power Unit",
        "Central Processing Unit",
        "Central Power Utility",
        "Core Program Unit"
      ],
      answers: ["central processing unit", "cpu"]
    },
    {
      difficulty: "easy",
      prompt: "Which company created the iPhone?",
      choices: [
        "Samsung",
        "Apple",
        "Google",
        "Huawei"
      ],
      answers: ["apple"]
    },
    {
      difficulty: "easy",
      prompt: "What does HTML stand for?",
      choices: [
        "Hyper Text Markup Language",
        "High Tech Machine Language",
        "Hyper Tool Multi Language",
        "Hyper Trainer Markup Language"
      ],
      answers: ["hyper text markup language", "html"]
    },
  
    // GEOGRAPHY
    {
      difficulty: "easy",
      prompt: "Which country has the largest population?",
      choices: [
        "USA",
        "Russia",
        "China",
        "India"
      ],
      answers: ["china"]
    },
    {
      difficulty: "easy",
      prompt: "Which is the largest desert?",
      choices: [
        "Gobi",
        "Kalahari",
        "Arabian",
        "Sahara"
      ],
      answers: ["sahara", "sahara desert"]
    },
    {
      difficulty: "easy",
      prompt: "Which river is the longest in the world?",
      choices: [
        "Amazon",
        "Nile",
        "Yangtze",
        "Congo"
      ],
      answers: ["nile", "nile river"]
    },
  
    // POP CULTURE
    {
      difficulty: "easy",
      prompt: "Who is the main character in the Harry Potter series?",
      choices: [
        "Ron Weasley",
        "Harry Potter",
        "Draco Malfoy",
        "Dumbledore"
      ],
      answers: ["harry potter", "harry"]
    },
    {
      difficulty: "easy",
      prompt: "Which superhero is known as the Dark Knight?",
      choices: [
        "Iron Man",
        "Batman",
        "Superman",
        "Spider-Man"
      ],
      answers: ["batman"]
    },
    {
      difficulty: "easy",
      prompt: "What metal is found in Wakanda?",
      choices: [
        "Titanium",
        "Palladium",
        "Adamantium",
        "Vibranium"
      ],
      answers: ["vibranium"]
    },
  
    // ANIMALS
    {
      difficulty: "easy",
      prompt: "What do bees make?",
      choices: [
        "Oil",
        "Milk",
        "Sugar",
        "Honey"
      ],
      answers: ["honey"]
    },
    {
      difficulty: "easy",
      prompt: "Which animal is the fastest on land?",
      choices: [
        "Cheetah",
        "Horse",
        "Tiger",
        "Leopard"
      ],
      answers: ["cheetah"]
    },
    {
      difficulty: "easy",
      prompt: "Which fruit keeps the doctor away?",
      choices: [
        "Apple",
        "Mango",
        "Banana",
        "Orange"
      ],
      answers: ["apple"]
    },
    {
      difficulty: "easy",
      prompt: "What do you call a baby cat?",
      choices: [
        "Puppy",
        "Calf",
        "Kitten",
        "Cub"
      ],
      answers: ["kitten"]
    },
    {
      difficulty: "medium",
      prompt: "Who invented the telephone?",
      choices: [
        "A. Alexander Graham Bell",
        "B. Thomas Edison",
        "C. Nikola Tesla",
        "D. Guglielmo Marconi"
      ],
      answers: ["alexander graham bell", "bell"]
    },
    {
      difficulty: "medium",
      prompt: "What gas do plants primarily absorb during photosynthesis?",
      choices: [
        "A. Oxygen",
        "B. Carbon Dioxide",
        "C. Nitrogen",
        "D. Hydrogen"
      ],
      answers: ["carbon dioxide", "co2"]
    },
    {
      difficulty: "medium",
      prompt: "Which element has the chemical symbol 'Fe'?",
      choices: [
        "A. Iron",
        "B. Fluorine",
        "C. Francium",
        "D. Fermium"
      ],
      answers: ["iron"]
    },
    {
      difficulty: "medium",
      prompt: "In computing, what does 'CPU' stand for?",
      choices: [
        "A. Central Process Utility",
        "B. Core Processing Unit",
        "C. Central Processing Unit",
        "D. Computer Power Unit"
      ],
      answers: ["central processing unit", "cpu"]
    },
    {
      difficulty: "medium",
      prompt: "Which country invented paper?",
      choices: [
        "A. Greece",
        "B. Egypt",
        "C. China",
        "D. India"
      ],
      answers: ["china"]
    },
    {
      difficulty: "medium",
      prompt: "Which organ in the human body regulates blood sugar levels?",
      choices: [
        "A. Liver",
        "B. Kidney",
        "C. Pancreas",
        "D. Heart"
      ],
      answers: ["pancreas"]
    },
    {
      difficulty: "medium",
      prompt: "What is the capital of Canada?",
      choices: [
        "A. Toronto",
        "B. Vancouver",
        "C. Montreal",
        "D. Ottawa"
      ],
      answers: ["ottawa"]
    },
    {
      difficulty: "medium",
      prompt: "What is H2O commonly known as?",
      choices: [
        "A. Hydrogen",
        "B. Salt",
        "C. Water",
        "D. Oxygen"
      ],
      answers: ["water"]
    },
    {
      difficulty: "medium",
      prompt: "Which continent is the largest by land area?",
      choices: [
        "A. Africa",
        "B. Asia",
        "C. Antarctica",
        "D. North America"
      ],
      answers: ["asia"]
    },
    {
      difficulty: "medium",
      prompt: "Which famous scientist developed the theory of relativity?",
      choices: [
        "A. Isaac Newton",
        "B. Albert Einstein",
        "C. Galileo Galilei",
        "D. Max Planck"
      ],
      answers: ["albert einstein", "einstein"]
    },
    {
      difficulty: "medium",
      prompt: "Which part of the cell contains genetic material?",
      choices: [
        "A. Cytoplasm",
        "B. Ribosome",
        "C. Mitochondria",
        "D. Nucleus"
      ],
      answers: ["nucleus"]
    },
    {
      difficulty: "medium",
      prompt: "What is the capital of South Korea?",
      choices: [
        "A. Seoul",
        "B. Busan",
        "C. Incheon",
        "D. Daegu"
      ],
      answers: ["seoul"]
    },
    {
      difficulty: "medium",
      prompt: "Which natural disaster is measured with the Richter scale?",
      choices: [
        "A. Tornado",
        "B. Hurricane",
        "C. Earthquake",
        "D. Flood"
      ],
      answers: ["earthquake"]
    },
    {
      difficulty: "medium",
      prompt: "What is the largest internal organ in the human body?",
      choices: [
        "A. Brain",
        "B. Liver",
        "C. Lung",
        "D. Stomach"
      ],
      answers: ["liver"]
    },
    {
      difficulty: "medium",
      prompt: "Which ocean is the deepest?",
      choices: [
        "A. Atlantic",
        "B. Indian",
        "C. Arctic",
        "D. Pacific"
      ],
      answers: ["pacific"]
    },
    {
      difficulty: "hard",
      prompt: "What is the rarest naturally occurring element on Earth?",
      choices: [
        "A. Francium",
        "B. Astatine",
        "C. Promethium",
        "D. Osmium"
      ],
      answers: ["astatine"]
    },
    {
      difficulty: "hard",
      prompt: "Which mathematician proved Fermat’s Last Theorem in 1994?",
      choices: [
        "A. Terence Tao",
        "B. Andrew Wiles",
        "C. Grigori Perelman",
        "D. Edward Witten"
      ],
      answers: ["andrew wiles", "wiles"]
    },
    {
      difficulty: "hard",
      prompt: "What is the only letter not appearing in any U.S. state name?",
      choices: [
        "A. Q",
        "B. Z",
        "C. J",
        "D. X"
      ],
      answers: ["q"]
    },
    {
      difficulty: "hard",
      prompt: "What is the heaviest naturally occurring noble gas?",
      choices: [
        "A. Xenon",
        "B. Radon",
        "C. Krypton",
        "D. Argon"
      ],
      answers: ["radon"]
    },
    {
      difficulty: "hard",
      prompt: "Which scientist proposed the uncertainty principle?",
      choices: [
        "A. Einstein",
        "B. Heisenberg",
        "C. Bohr",
        "D. Pauli"
      ],
      answers: ["heisenberg"]
    },
    {
      difficulty: "hard",
      prompt: "What ancient kingdom was ruled by Mansa Musa?",
      choices: [
        "A. Mali Empire",
        "B. Ghana Empire",
        "C. Songhai Empire",
        "D. Axum"
      ],
      answers: ["mali empire", "mali"]
    },
    {
      difficulty: "hard",
      prompt: "Which Greek letter is used to symbolize wavelength?",
      choices: [
        "A. Lambda",
        "B. Sigma",
        "C. Theta",
        "D. Omega"
      ],
      answers: ["lambda"]
    },
    {
      difficulty: "hard",
      prompt: "Which philosopher wrote 'The Republic'?",
      choices: [
        "A. Aristotle",
        "B. Socrates",
        "C. Plato",
        "D. Homer"
      ],
      answers: ["plato"]
    },
    {
      difficulty: "hard",
      prompt: "What is the second largest moon in the Solar System?",
      choices: [
        "A. Europa",
        "B. Titan",
        "C. Ganymede",
        "D. Callisto"
      ],
      answers: ["titan"]
    },
    {
      difficulty: "hard",
      prompt: "Which scientist discovered penicillin?",
      choices: [
        "A. Louis Pasteur",
        "B. Robert Koch",
        "C. Alexander Fleming",
        "D. Joseph Lister"
      ],
      answers: ["alexander fleming", "fleming"]
    },
    {
      difficulty: "hard",
      prompt: "What is the smallest prime number greater than 100?",
      choices: [
        "A. 101",
        "B. 103",
        "C. 107",
        "D. 109"
      ],
      answers: ["101"]
    },
    {
      difficulty: "hard",
      prompt: "Which civilization built the ancient city of Machu Picchu?",
      choices: [
        "A. Maya",
        "B. Aztec",
        "C. Inca",
        "D. Olmec"
      ],
      answers: ["inca"]
    },
    {
      difficulty: "hard",
      prompt: "Which physicist coined the term 'black hole'?",
      choices: [
        "A. John Wheeler",
        "B. Stephen Hawking",
        "C. Roger Penrose",
        "D. Karl Schwarzschild"
      ],
      answers: ["john wheeler", "wheeler"]
    },
    {
      difficulty: "hard",
      prompt: "What is the chemical formula for ozone?",
      choices: [
        "A. O2",
        "B. O3",
        "C. O4",
        "D. O1"
      ],
      answers: ["o3"]
    },
    {
      difficulty: "hard",
      prompt: "Which war inspired the novel 'All Quiet on the Western Front'?",
      choices: [
        "A. World War I",
        "B. World War II",
        "C. Vietnam War",
        "D. Franco-Prussian War"
      ],
      answers: ["world war i", "ww1", "world war 1"]
    },
    {
      difficulty: "hard",
      prompt: "What is the approximate value of the mathematical constant e?",
      choices: [
        "A. 2.14",
        "B. 2.72",
        "C. 3.14",
        "D. 1.61"
      ],
      answers: ["2.72", "2.718", "e"]
    },
    {
      difficulty: "hard",
      prompt: "Who painted 'The Garden of Earthly Delights'?",
      choices: [
        "A. Hieronymus Bosch",
        "B. Pieter Bruegel",
        "C. Caravaggio",
        "D. El Greco"
      ],
      answers: ["hieronymus bosch", "bosch"]
    },
    {
      difficulty: "hard",
      prompt: "Which continent has the most countries?",
      choices: [
        "A. Europe",
        "B. Asia",
        "C. Africa",
        "D. South America"
      ],
      answers: ["africa"]
    },
    {
      difficulty: "hard",
      prompt: "What is the SI unit of electrical resistance?",
      choices: [
        "A. Tesla",
        "B. Ohm",
        "C. Newton",
        "D. Volt"
      ],
      answers: ["ohm"]
    },
    {
      difficulty: "hard",
      prompt: "Who developed the first practical telephone?",
      choices: [
        "A. Nikola Tesla",
        "B. Guglielmo Marconi",
        "C. Alexander Graham Bell",
        "D. Thomas Edison"
      ],
      answers: ["alexander graham bell", "bell"]
    },
    {
      difficulty: "hard",
      prompt: "What is the capital of Mongolia?",
      choices: [
        "A. Astana",
        "B. Ulaanbaatar",
        "C. Bishkek",
        "D. Tashkent"
      ],
      answers: ["ulaanbaatar"]
    },
    {
      difficulty: "hard",
      prompt: "What is the longest bone in the human body?",
      choices: [
        "A. Tibia",
        "B. Femur",
        "C. Humerus",
        "D. Fibula"
      ],
      answers: ["femur"]
    },
    {
      difficulty: "hard",
      prompt: "Which country has the most time zones?",
      choices: [
        "A. Russia",
        "B. United States",
        "C. France",
        "D. China"
      ],
      answers: ["france"]
    },
    {
      difficulty: "hard",
      prompt: "Which organelle is responsible for photosynthesis?",
      choices: [
        "A. Mitochondria",
        "B. Ribosome",
        "C. Chloroplast",
        "D. Golgi Apparatus"
      ],
      answers: ["chloroplast"]
    },
    {
      difficulty: "hard",
      prompt: "What is the speed of light in a vacuum (km/s)?",
      choices: [
        "A. 200,000",
        "B. 150,000",
        "C. 300,000",
        "D. 250,000"
      ],
      answers: ["300000", "300,000", "3e5", "3×10^5"]
    },
    {
      difficulty: "hard",
      prompt: "Who is known as the father of geometry?",
      choices: [
        "A. Euclid",
        "B. Archimedes",
        "C. Pythagoras",
        "D. Aristotle"
      ],
      answers: ["euclid"]
    },
    {
      difficulty: "hard",
      prompt: "Which gas makes up most of Earth's atmosphere?",
      choices: [
        "A. Oxygen",
        "B. Carbon Dioxide",
        "C. Nitrogen",
        "D. Hydrogen"
      ],
      answers: ["nitrogen"]
    },
    {
      difficulty: "hard",
      prompt: "Which country has the longest coastline?",
      choices: [
        "A. Russia",
        "B. Canada",
        "C. Australia",
        "D. Indonesia"
      ],
      answers: ["canada"]
    },
    {
      difficulty: "hard",
      prompt: "Which physicist created the laws of planetary motion?",
      choices: [
        "A. Kepler",
        "B. Copernicus",
        "C. Galileo",
        "D. Newton"
      ],
      answers: ["kepler", "johannes kepler"]
    },
    {
      difficulty: "hard",
      prompt: "Which metal has the highest melting point?",
      choices: [
        "A. Tungsten",
        "B. Platinum",
        "C. Titanium",
        "D. Osmium"
      ],
      answers: ["tungsten"]
    },
    {
      difficulty: "hard",
      prompt: "Which planet rotates on its side?",
      choices: [
        "A. Neptune",
        "B. Uranus",
        "C. Saturn",
        "D. Mercury"
      ],
      answers: ["uranus"]
    },
    {
      difficulty: "hard",
      prompt: "Which language has the oldest written texts?",
      choices: [
        "A. Latin",
        "B. Sanskrit",
        "C. Sumerian",
        "D. Egyptian"
      ],
      answers: ["sumerian"]
    },
    {
      difficulty: "hard",
      prompt: "What is the largest desert in the world?",
      choices: [
        "A. Sahara",
        "B. Arabian",
        "C. Gobi",
        "D. Antarctic"
      ],
      answers: ["antarctic", "antarctica"]
    },
    {
      difficulty: "hard",
      prompt: "What is the center of an atom called?",
      choices: [
        "A. Nucleus",
        "B. Proton",
        "C. Neutron",
        "D. Core"
      ],
      answers: ["nucleus"]
    },
    {
      difficulty: "hard",
      prompt: "Which empire built the Hagia Sophia before it became a mosque?",
      choices: [
        "A. Roman Empire",
        "B. Byzantine Empire",
        "C. Ottoman Empire",
        "D. Persian Empire"
      ],
      answers: ["byzantine empire", "byzantine"]
    },
    {
      difficulty: "hard",
      prompt: "What is the most abundant element in the universe?",
      choices: [
        "A. Hydrogen",
        "B. Helium",
        "C. Oxygen",
        "D. Carbon"
      ],
      answers: ["hydrogen"]
    },
    {
      difficulty: "hard",
      prompt: "Which scientist discovered radioactivity?",
      choices: [
        "A. Curie",
        "B. Becquerel",
        "C. Rutherford",
        "D. Roentgen"
      ],
      answers: ["henri becquerel", "becquerel"]
    },
    {
      difficulty: "hard",
      prompt: "Which African country was formerly known as Abyssinia?",
      choices: [
        "A. Ethiopia",
        "B. Sudan",
        "C. Eritrea",
        "D. Djibouti"
      ],
      answers: ["ethiopia"]
    },
    {
      difficulty: "hard",
      prompt: "What is the term for animals that eat both plants and meat?",
      choices: [
        "A. Herbivore",
        "B. Carnivore",
        "C. Omnivore",
        "D. Insectivore"
      ],
      answers: ["omnivore"]
    },
    {
      difficulty: "hard",
      prompt: "What is the largest known star in the universe?",
      choices: [
        "A. Betelgeuse",
        "B. UY Scuti",
        "C. VY Canis Majoris",
        "D. RW Cephei"
      ],
      answers: ["uy scuti"]
    },
    {
      difficulty: "hard",
      prompt: "Which European city is known as the 'City of a Hundred Spires'?",
      choices: [
        "A. Prague",
        "B. Vienna",
        "C. Budapest",
        "D. Krakow"
      ],
      answers: ["prague"]
    },
    {
      difficulty: "hard",
      prompt: "Which treaty ended World War I?",
      choices: [
        "A. Treaty of Paris",
        "B. Treaty of Versailles",
        "C. Treaty of Ghent",
        "D. Treaty of Tordesillas"
      ],
      answers: ["treaty of versailles", "versailles"]
    },
    {
      difficulty: "hard",
      prompt: "What is the main gas found on Jupiter?",
      choices: [
        "A. Methane",
        "B. Hydrogen",
        "C. Helium",
        "D. Nitrogen"
      ],
      answers: ["hydrogen"]
    },
    {
      difficulty: "hard",
      prompt: "In computing, what does 'CPU' stand for?",
      choices: [
        "A. Central Processing Unit",
        "B. Computer Power Unit",
        "C. Central Program Unit",
        "D. Core Processing Utility"
      ],
      answers: ["central processing unit"]
    },
    {
      difficulty: "hard",
      prompt: "Which country invented gunpowder?",
      choices: [
        "A. India",
        "B. China",
        "C. Persia",
        "D. Japan"
      ],
      answers: ["china"]
    },
    {
      difficulty: "hard",
      prompt: "What is the chemical symbol for potassium?",
      choices: [
        "A. Po",
        "B. P",
        "C. K",
        "D. Pt"
      ],
      answers: ["k"]
    },
    {
      difficulty: "hard",
      prompt: "Which scientist first proposed continental drift?",
      choices: [
        "A. Alfred Wegener",
        "B. Charles Lyell",
        "C. Harry Hess",
        "D. James Hutton"
      ],
      answers: ["alfred wegener", "wegener"]
    },
    {
      difficulty: "hard",
      prompt: "What is the largest moon of Saturn?",
      choices: [
        "A. Titan",
        "B. Rhea",
        "C. Enceladus",
        "D. Dione"
      ],
      answers: ["titan"]
    },
    {
      difficulty: "hard",
      prompt: "Which gas is responsible for the greenhouse effect?",
      choices: [
        "A. Nitrogen",
        "B. Oxygen",
        "C. Carbon Dioxide",
        "D. Helium"
      ],
      answers: ["carbon dioxide", "co2"]
    },
    {
      difficulty: "hard",
      prompt: "Who developed the theory of general relativity?",
      choices: [
        "A. Isaac Newton",
        "B. Albert Einstein",
        "C. Max Planck",
        "D. Niels Bohr"
      ],
      answers: ["albert einstein", "einstein"]
    },
    {
      difficulty: "hard",
      prompt: "Which country is known as the Land of the Rising Sun?",
      choices: [
        "A. China",
        "B. Thailand",
        "C. Japan",
        "D. South Korea"
      ],
      answers: ["japan"]
    },
    {
      difficulty: "hard",
      prompt: "Which ancient civilization built the city of Petra?",
      choices: [
        "A. Nabateans",
        "B. Romans",
        "C. Persians",
        "D. Greeks"
      ],
      answers: ["nabateans", "nabataean"]
    },
    {
      difficulty: "hard",
      prompt: "What is the largest internal organ in the human body?",
      choices: [
        "A. Brain",
        "B. Liver",
        "C. Heart",
        "D. Lungs"
      ],
      answers: ["liver"]
    },
    {
      difficulty: "hard",
      prompt: "Which radioactive element was discovered by Marie Curie?",
      choices: [
        "A. Radon",
        "B. Polonium",
        "C. Uranium",
        "D. Cesium"
      ],
      answers: ["polonium"]
    }  
  ];